/* Supply Access: shared sliding pill for every pill tab / segmented control.
   The active state stays owned by each section's own JS (is-on / bb-on classes);
   this file only watches those classes and moves one pill behind the tabs with
   the same stretch-then-spring motion as the phone cart tabs (Apple tabnav). */
(function () {
  'use strict';

  var GROUPS = [
    { g: '.bb-ex__tabs', t: '.bb-ex__tab' },
    { g: '.bb-sp__tabs', t: '.bb-sp__tab' },
    { g: '.bb-ct__chips', t: '.bb-ct__chip' },
    { g: '.bb-hl__tabs', t: '.bb-hl__tab' },
    { g: '.bb-sh__tabs', t: '.bb-sh__tab' },
    { g: '.bb-fp__tabs', t: '.bb-fp__tab' },
    { g: '.bb-col__filters', t: '.bb-chipf' },
    { g: '.bb-chips', t: '.bb-chip' },
    { g: '.bb-bd__seg', t: 'button' },
    { g: '.bb-toggle', t: 'button' },
    { g: '.bb-fn__chips', t: 'button' },
    { g: '.bb-mm__tabs', t: '.bb-mm__tab' },
    { g: '.bb-mmm__tabs', t: '.bb-mmm__tab' }
  ];
  var ON = ['is-on', 'bb-on'];
  var STRETCH = 'cubic-bezier(0.55, 0, 0.85, 0.4)';
  var SPRING = 'cubic-bezier(0.2, 1.45, 0.35, 1)';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isOn(el) {
    return ON.some(function (c) { return el.classList.contains(c); });
  }

  function rectOf(el) {
    return { l: el.offsetLeft, t: el.offsetTop, w: el.offsetWidth, h: el.offsetHeight };
  }

  function px(r) {
    return { left: r.l + 'px', top: r.t + 'px', width: r.w + 'px', height: r.h + 'px' };
  }

  function place(pill, r) {
    var s = px(r);
    pill.style.left = s.left; pill.style.top = s.top; pill.style.width = s.width; pill.style.height = s.height;
  }

  /* where the pill is drawn right now (mid-animation included) */
  function liveRect(pill) {
    var cs = getComputedStyle(pill);
    return { l: parseFloat(cs.left) || 0, t: parseFloat(cs.top) || 0, w: parseFloat(cs.width) || 0, h: parseFloat(cs.height) || 0 };
  }

  function frames(a, b) {
    var sameRow = Math.abs(a.t - b.t) < 3 && Math.abs(a.h - b.h) < 3;
    var sameCol = Math.abs(a.l - b.l) < 3 && Math.abs(a.w - b.w) < 3;
    var mid;
    if (sameRow) {
      /* lead edge races ahead, pill squashes a touch, then springs into place */
      var fwd = b.l > a.l;
      var l = fwd ? a.l : b.l;
      var w = fwd ? b.l + b.w - a.l : a.l + a.w - b.l;
      mid = Object.assign(px({ l: l, t: a.t, w: w, h: a.h }), { transform: 'scaleY(0.9)' });
    } else if (sameCol) {
      var down = b.t > a.t;
      var t = down ? a.t : b.t;
      var h = down ? b.t + b.h - a.t : a.t + a.h - b.t;
      mid = Object.assign(px({ l: a.l, t: t, w: a.w, h: h }), { transform: 'scaleX(0.96)' });
    }
    var start = Object.assign(px(a), { transform: 'none' });
    var end = Object.assign(px(b), { transform: 'none' });
    if (!mid) {
      start.easing = SPRING;
      return { k: [start, end], d: 520 };
    }
    start.easing = STRETCH;
    mid.offset = 0.42;
    mid.easing = SPRING;
    return { k: [start, mid, end], d: 560 };
  }

  function init(group, tabSel) {
    if (group.dataset.bbPill) return;
    var tabs = Array.prototype.slice.call(group.querySelectorAll(':scope > ' + tabSel));
    if (tabs.length < 2) return;
    var active = tabs.filter(isOn)[0];
    if (!active) return;

    /* lift the active look off the tab and onto the pill */
    var cs = getComputedStyle(active);
    var pill = document.createElement('span');
    pill.className = 'bb-pg__pill';
    pill.setAttribute('aria-hidden', 'true');
    pill.style.background = cs.backgroundColor;
    pill.style.boxShadow = cs.boxShadow;
    pill.style.borderRadius = cs.borderTopLeftRadius;
    if (parseFloat(cs.borderTopWidth) > 0) pill.style.border = cs.borderTopWidth + ' solid ' + cs.borderTopColor;
    group.dataset.bbPill = '1';
    group.classList.add('bb-pg');
    tabs.forEach(function (t) { t.classList.add('bb-pg__t'); });
    group.insertBefore(pill, group.firstChild);

    var current = active;
    place(pill, rectOf(active));

    function sync() {
      var next = tabs.filter(isOn)[0];
      if (!next) { pill.style.opacity = '0'; return; }
      pill.style.opacity = '';
      if (next === current) { if (!pill.getAnimations().length) place(pill, rectOf(next)); return; }
      var from = liveRect(pill);
      var to = rectOf(next);
      current = next;
      pill.getAnimations().forEach(function (a) { a.cancel(); });
      place(pill, to);
      if (reduce.matches || !pill.animate || !from.w || !to.w) return;
      var f = frames(from, to);
      pill.animate(f.k, { duration: f.d, fill: 'none' });
    }

    group._bbPillPlace = function () { if (!pill.getAnimations().length) place(pill, rectOf(current)); };
    new MutationObserver(sync).observe(group, { subtree: true, attributes: true, attributeFilter: ['class'] });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(group._bbPillPlace);
      ro.observe(group);
      tabs.forEach(function (t) { ro.observe(t); });
    }
  }

  function scan(root) {
    GROUPS.forEach(function (x) {
      (root || document).querySelectorAll(x.g).forEach(function (g) { init(g, x.t); });
    });
  }

  function boot() {
    scan(document);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        document.querySelectorAll('.bb-pg').forEach(function (g) { if (g._bbPillPlace) g._bbPillPlace(); });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
